// THE FILE SHELLVERSIONINFO.TS IS AUTOMATICALLY GENERATED DURING BUILD PROCESS
// MANUAL CHANGES TO THIS FILE WILL BE OVERWRITTEN !!!

export const SHELL_VERSION_INFO = {
VERSION : '1.27.1',
BUILD_TS: '2026-05-26T14:06:53.926Z'
};

